var React = require('react');

function Pie (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M5.125 20.5C5.125 28.9914 12.0086 35.875 20.5 35.875C28.9914 35.875 35.875 28.9914 35.875 20.5C35.875 12.0086 28.9914 5.125 20.5 5.125V20.5H5.125Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M0 15.375C0 6.88362 6.88362 0 15.375 0V15.375H0Z","key":1}),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"id":"grad","x1":"0%","y1":"0%","x2":"100%","y2":"0%"},[React.createElement("stop",{"offset":"0%","style":{"stopColor":"rgba(99, 102, 241, 1)","stopOpacity":"1"},"key":0}),React.createElement("stop",{"offset":"100%","style":{"stopColor":"rgba(66, 165, 245, 1)","stopOpacity":"1"},"key":1})]))]);
}

Pie.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"currentColor"};

module.exports = Pie;

Pie.default = Pie;
